(function() {
  const PAPER_MAP = {
    'Natural': 'NATURAL',
    'Vellum White': 'VELIUM_WHITE',
    'Pistachio': 'PISTACHIO',
    'Limestone': 'LIMESTONE',
    'Mist': 'MIST',
    'Azure Blue': 'AZURE_BLUE',
    'Cool Blue': 'COOL_BLUE',
    'Pale Grey': 'PALE_GREY'
  };
  const LINE_MAP = {
    'Standard Lines': 1,
    'Fine Lines': 2,
    'Boulevard Lines': 3,
    'Avenue Lines': 4,
    'Dot Grid': 5,
    'Seine Lines': 6,
    'Standard Dot Lines': 7,
    'Large Dot Lines': 8,
    'Zebra Lines': 9,
    '1827 Lines': 10
  };

  function init(wrap) {
    if (wrap.dataset.initialized) return;
    wrap.dataset.initialized = '1';

    let URLS;
    try {
      URLS = {
        bg: JSON.parse(wrap.dataset.bgUrls),
        lines: JSON.parse(wrap.dataset.linesUrls)
      };
    } catch (e) {
      console.error('[notebook-preview] bad JSON', e);
      return;
    }

    const bgEl = wrap.querySelector('[data-notebook-bg]');
    const linesEl = wrap.querySelector('[data-notebook-lines]');
    let lastBg = '';
    let lastLines = '';

   function swapLayer(el, url, last) {
  if (!url || url === last) return last;
  el.classList.add('is-swapping');
  const pre = new Image();
  pre.onload = function () {
    el.src = url;
    requestAnimationFrame(function () {
      el.classList.remove('is-swapping');
    });
  };
  pre.onerror = function () {
    el.classList.remove('is-swapping');
    console.warn('[notebook-preview] 404', url);
  };
  pre.src = url;
  // Fallback : if the image is cached, onload may not fire
  if (pre.complete && pre.naturalWidth > 0) {
    el.src = url;
    el.classList.remove('is-swapping');
  }
  return url;
}
    function read() {
      let paper = 'NATURAL';
      let line = 1;
      document.querySelectorAll('input[type="radio"]:checked').forEach(function (el) {
        const v = el.value;
        if (!v) return;
        if (PAPER_MAP[v]) paper = PAPER_MAP[v];
        if (LINE_MAP[v] !== undefined) line = LINE_MAP[v];
      });
      if (URLS.bg[paper]) lastBg = swapLayer(bgEl, URLS.bg[paper], lastBg);
      if (URLS.lines[line]) lastLines = swapLayer(linesEl, URLS.lines[line], lastLines);
    }

    let raf = 0;
    function queueRead() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(read);
    }

    read();

    ['change', 'input', 'click'].forEach(function (evt) {
      document.addEventListener(evt, queueRead, true);
    });

    const observer = new MutationObserver(queueRead);
    document.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      observer.observe(radio, { attributes: true, attributeFilter: ['checked'] });
    });
  }

  function bootAll() {
    document.querySelectorAll('[data-notebook-preview]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', bootAll);
})();